import { css } from '@emotion/react';
import type { Keyframes } from '@emotion/serialize';

import { fadeInOpacity, spin } from './keyframes';

interface GetAnimationCSSOptions {
  keyframes: Keyframes;
  iterationCount: string | number;
  timingFn: string;
  duration: number;
}

const FADE_IN_DURATION = 300;
const FADE_IN_TIMING_FN = 'ease-in';

const SPIN_DURATION = 900;
const SPIN_TIMING_FN = 'linear';

const getAnimationCSS = ({
  keyframes,
  iterationCount,
  timingFn,
  duration,
}: GetAnimationCSSOptions) => css`
  animation-name: ${keyframes};
  animation-iteration-count: ${iterationCount};
  animation-timing-function: ${timingFn};
  animation-duration: ${duration}ms;
`;

export const fadeInAnimation = getAnimationCSS({
  keyframes: fadeInOpacity,
  iterationCount: 1,
  timingFn: FADE_IN_TIMING_FN,
  duration: FADE_IN_DURATION,
});

export const spinAnimation = getAnimationCSS({
  keyframes: spin,
  iterationCount: 'infinite',
  timingFn: SPIN_TIMING_FN,
  duration: SPIN_DURATION,
});
